import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseURL } from "../../App";
import "./admin.css";
import { Link } from "react-router-dom";

const Dashboard = () => {
  const [aboutData, setAboutData] = useState(null);
  const [headerData, setHeaderData] = useState(null);
  const [contactData, setContactData] = useState(null);
  const [portfolioData, setPortfolioData] = useState(null);
  const [serviceData, setServiceData] = useState(null);
  const [experienceData, setExperienceData] = useState(null);
  const [apiStatus, setApiStatus] = useState("Checking...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          aboutResponse,
          headerResponse,
          contactResponse,
          portfolioResponse,
          serviceResponse,
          experienceResponse,
        ] = await Promise.all([
          axios.get(`${baseURL}/api/about`, { withCredentials: true }),
          axios.get(`${baseURL}/api/header`, { withCredentials: true }),
          axios.get(`${baseURL}/api/contact`, { withCredentials: true }),
          axios.get(`${baseURL}/api/portfolio`, { withCredentials: true }),
          axios.get(`${baseURL}/api/services`, { withCredentials: true }),
          axios.get(`${baseURL}/api/experience`, { withCredentials: true }),
        ]);

        setAboutData(aboutResponse.data);
        setHeaderData(headerResponse.data);
        setContactData(contactResponse.data);
        setPortfolioData(portfolioResponse.data);
        setServiceData(serviceResponse.data);
        setExperienceData(experienceResponse.data);

        setApiStatus("API Online");
      } catch (error) {
        console.error("Error fetching data:", error);
        setApiStatus("API Offline or Error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  if (loading) {
    return (
      <div className="admin-section">
        <p>Loading dashboard data...</p>
      </div>
    );
  }

  if (apiStatus !== "API Online") {
    return (
      <div className="admin-section">
        <h2>Dashboard</h2>
        <p className="api-error">API Status: {apiStatus}</p>
      </div>
    );
  }

  return (
    <div className="admin-section dashboard">
      <h2>Dashboard</h2>

      <div className="dashboard-summary">
        {/* About Section */}
        <div className="dashboard-section about">
          <div className="section-header">
            <h3>About</h3>
            <p>Entries: {aboutData ? aboutData.length : 0}</p>
          </div>
          {aboutData && aboutData.length > 0 && (
            <div className="last-updated">
              <p>Last Updated: {formatDate(aboutData[aboutData.length - 1].updatedAt)}</p>
            </div>
          )}
          <Link to="/admin/about" className="edit-link">
            Edit About
          </Link>
        </div>

        {/* Header Section */}
        <div className="dashboard-section header">
          <div className="section-header">
            <h3>Header</h3>
            <p>Entries: {headerData ? headerData.length : 0}</p>
          </div>
          {headerData && ( // Check if headerData exists
            <div className="last-updated">
              <p>Last Image: {headerData[headerData.length - 1].image || "N/A"}</p>
            </div>
          )}
          <Link to="/admin/header" className="edit-link">
            Edit Header
          </Link>
        </div>

        {/* Contact Section */}
        <div className="dashboard-section contact">
          {" "}
          {/* Added Contact section */}
          <div className="section-header">
            <h3>Contact</h3>
            <p>Entries: {contactData ? contactData.length : 0}</p>
          </div>
          {contactData && contactData.length > 0 && (
            <div className="last-updated">
              <p>Last Email: {contactData[contactData.length - 1].email}</p>
            </div>
          )}
          <Link to="/admin/contact" className="edit-link">
            Edit Contact
          </Link>
        </div>

        {/* Portfolio Section */}
        <div className="dashboard-section portfolio">
          <div className="section-header">
            <h3>Portfolio</h3>
            <p>Entries: {portfolioData ? portfolioData.length : 0}</p>
          </div>
          {portfolioData && portfolioData.length > 0 && (
            <div className="last-updated">
              <p>Last Project: {portfolioData[portfolioData.length - 1].titleEn}</p>
            </div>
          )}
          <Link to="/admin/portfolio" className="edit-link">
            Edit Portfolio
          </Link>
        </div>

        {/* Service Section */}
        <div className="dashboard-section service">
          <div className="section-header">
            <h3>Services</h3>
            <p>Entries: {serviceData ? serviceData.length : 0}</p>
          </div>
          {serviceData && serviceData.length > 0 && (
            <div className="last-updated">
              <p>Last Service: {serviceData[serviceData.length - 1].titleEn}</p>
            </div>
          )}
          <Link to="/admin/services" className="edit-link">
            Edit Services
          </Link>
        </div>

        {/* Experience Section */}
        <div className="dashboard-section experience">
          <div className="section-header">
            <h3>Experience</h3>
            <p>Entries: {experienceData ? experienceData.length : 0}</p>
          </div>
          {experienceData && experienceData.length > 0 && (
            <div className="recent-items">
              {" "}
              {/* Use recent-items class */}
              <h4>Recent Experiences:</h4>
              <ul>
                {experienceData.slice(0, 3).map((exp) => (
                  <li key={exp._id}>
                    {exp.categoryEn} (Updated: {formatDate(exp.updatedAt)})
                  </li>
                ))}
              </ul>
            </div>
          )}

          <Link to="/admin/experience" className="edit-link">
            Edit Experience
          </Link>
        </div>
      </div>

      {/* ... (optional Recent Updates section) */}
    </div>
  );
};

export default Dashboard;
